import { createSlice } from "@reduxjs/toolkit";

const storedUser = localStorage.getItem("user");

const parsedUser = storedUser ? JSON.parse(storedUser) : null;

const initialState = {
  user: parsedUser
    ? {
        id: parsedUser.id,
        token: parsedUser.token,
      }
    : {
        id: "",
        token: "",
      },
  isLogged: !!parsedUser?.token,
  isLoading: false,
  resetPassword: false,
  isHydrated: true,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true;
    },

    stopLoading: (state) => {
      state.isLoading = false;
    },

    setUser: (state, action) => {
      const { id, token } = action.payload;

      state.user = { id, token };
      state.isLogged = true;

      localStorage.setItem("user", JSON.stringify({ id, token }));
    },

    setResetPassword: (state, action) => {
      state.resetPassword = action.payload;
    },

    singOut: (state) => {
      state.user = { id: "", token: "" };
      state.isLogged = false;
      state.resetPassword = false;

      localStorage.removeItem("user");
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, startLoading, stopLoading, singOut, setResetPassword } =
  userSlice.actions;
